// Module-level singleton Map holding the Window handle returned by
// window.open() for each document popout. Lives in `model/` per FSD — it's
// feature-local state, not reactive, and not a dependency of other slices.

const registry = new Map<string, Window>()

export function register(documentKey: string, win: Window): void {
  registry.set(documentKey, win)
}

export function get(documentKey: string): Window | undefined {
  return registry.get(documentKey)
}

export function forget(documentKey: string): void {
  registry.delete(documentKey)
}

export function hasHandle(documentKey: string): boolean {
  return registry.has(documentKey)
}

// Test-only reset hook. Not part of the slice's public API.
export function __reset(): void {
  registry.clear()
}
